import { Text, Space } from 'farmhub-ui-core';

import * as S from './styles';
import { Content } from './styles';

type ErrorDomainNotFoundProps = {
  isLoading: boolean;
  onSignIn: VoidFunction;
  onSignUp: VoidFunction;
  onContact: VoidFunction;
};

const ErrorDomainNotFoundDesktop = ({
  isLoading,
  onSignIn,
  onSignUp,
  onContact,
}: ErrorDomainNotFoundProps): JSX.Element => (
  <>
    <S.Container>
      <Content>
        <S.ErrorImage src="https://public-asset-cdn.ecovation.vn/master/no-data/digital_menu_no_data.png" />

        <Space height={24} />
        <Text color="dark" size="lg" weight="extraBold">
          Đường dẫn truy cập không đúng
        </Text>
        <Space height={12} />
        <Text
          color="main"
          style={{ maxWidth: '420px', textAlign: 'center' }}
          weight="bold"
        >
          Vui lòng sử dụng đường dẫn truy cập theo định dạng https://(tên miền
          đã đăng ký).hubtech.asia
        </Text>
        <Space height={22} />
        {/* <Row>
          <Text
            color="secondary"
            style={{ maxWidth: '420px', textAlign: 'left' }}
          >
            Nếu bạn chưa đăng ký. Vui lòng bấm{' '}
            <Text
              style={{ cursor: 'pointer' }}
              color="main"
              onClick={() => onSignUp()}
            >
              VÀO ĐÂY
            </Text>{' '}
            để đăng ký.
          </Text>
        </Row>
        <Space height={6} />
        <Row>
          <Text
            color="secondary"
            style={{ maxWidth: '420px', textAlign: 'left' }}
          >
            Nếu bạn đã đăng ký. Vui lòng{' '}
            <Text
              style={{ cursor: 'pointer' }}
              color="main"
              onClick={() => onContact()}
            >
              liên hệ với chúng tôi
            </Text>{' '}
            để được hỗ trợ.
          </Text>
        </Row> */}
      </Content>
    </S.Container>
  </>
);

export default ErrorDomainNotFoundDesktop;
